import { render, staticRenderFns } from "./DetailVersionList.vue?vue&type=template&id=4a472bfc&scoped=true&"
import script from "./DetailVersionList.vue?vue&type=script&lang=js&"
export * from "./DetailVersionList.vue?vue&type=script&lang=js&"
import style0 from "./DetailVersionList.vue?vue&type=style&index=0&id=4a472bfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a472bfc",
  null
  
)

export default component.exports